import { l } from '@manychat/manyui'

import { alert } from 'common/core'
import { isRequestError } from 'utils/api/mcApi/RequestError'

export const handleCatchError = (error: unknown) =>
  isRequestError(error) && error.response
    ? alert(error.response, 'danger')
    : alert(l.translate('Something went wrong on the server. Please try again.'), 'danger')
